import { z } from 'zod';
import { paginationQuerySchema } from './pagination.schema.js';
/**
 * GitHub module query schemas — batch-2 zod migration (gh#750).
 * NOTE: z.coerce.boolean() is FORBIDDEN — use z.enum(['true','false']).transform(...)
 */
/** GET /api/github/feed */
export const feedQuerySchema = paginationQuerySchema.extend({
    repo: z.string().optional(),
    severity: z.string().optional(),
    author: z.string().optional(),
    hasRoadmap: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => (v === undefined ? undefined : v === 'true')),
});
/** GET /api/github/feed/stats */
export const feedStatsQuerySchema = z.object({
    days: z.coerce.number().int().positive().optional().default(30),
});
/** GET /api/github/open-prs */
export const openPRsQuerySchema = z.object({
    baseBranchOnly: z
        .enum(['true', 'false'])
        .optional()
        .transform((v) => v === 'true'),
});
//# sourceMappingURL=github.schema.js.map